import script from "./supplement-label.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-label.vue?vue&type=script&setup=true&lang=js"

import "./supplement-label.vue?vue&type=style&index=0&id=9fdfa1e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fdfa1e8"]])

export default __exports__